module.exports = __webpack_public_path__ + "static/media/british-council.0e541ca3.png";